import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { Button, TextLink, Typography } from '@repo/ui';

import { AppLink } from 'src/components/layouts/AuthedLayout/AuthedLayout';
import { OrdersTable } from 'src/components/OrdersTable/OrdersTable';
import { Route as OrderKitsRoute } from 'src/routes/_authed/order-kit';
import { Route as PortalRoute } from 'src/routes/_authed/portal';

const Orders = () => {
  const navigate = useNavigate();
  return (
    <div className='flex flex-column gap-2 overflow-hidden flex-grow-1'>
      <TextLink<typeof AppLink>
        label='Back to Portal'
        to={PortalRoute.to}
        LinkComponent={AppLink}
        preload='intent'
        replace
        iconNameLeft='chevronBack'
      />
      <div className='flex flex-between'>
        <Typography variant='heading-m'>Order History</Typography>
        <Button
          label='Start New Order'
          size={'small'}
          color={'purple'}
          onClick={() => navigate({ to: OrderKitsRoute.to })}
        />
      </div>
      <OrdersTable />
    </div>
  );
};

export const Route = createFileRoute('/_authed/orders')({
  preload: true,
  component: Orders,
});
